import React from 'react';
import { useSsoOptional } from '@discover-frontend/auth';

import { getAccountsSessionReady } from 'src/utils/getAccountsSessionReady';
import { useGetAllUserProducts } from './api/hooks/use-get-all-user-products';
import { ProductPanel } from './components/product-panel';

const HomeContainer = () => {
  const sso = useSsoOptional();
  const sessionReady = getAccountsSessionReady(sso);

  const { data } = useGetAllUserProducts(sessionReady);

  return (
    <div className="pt-12 pb-20">
      <ProductPanel products={data || []} />
    </div>
  );
};

export default HomeContainer;
